<template>
  <div>
    <div class="hello flex" v-if="this.ml">
      <div class="home-left">
        <div class="home-left-top flex" v-if="!UseSimpleView" >
          <div class="home-left-top-one" v-if="!UseSimpleView" >
            <div class="home-left-top-content">
              <h3 class="a-title">可用余额</h3>
              <div class="flex">
                <div class="home-left-top-capital">
                  <strong>{{SubAccountLimit ? currAgentInfo.CurrUsable : "***"}}</strong>
                  <span>{{CurrencyName}}</span><br>
                  <span>累计佣金（{{SubAccountLimit ? currAgentInfo.TotalCommissionProfit : "***"}} {{CurrencyName}}）</span><br>
                  <span>其中未结算收入（{{SubAccountLimit ? currAgentInfo.UnBalanceCommissionProfit : "***"}} {{CurrencyName}}）</span>
                </div>
                <div class="home-left-top-option" v-show="SubAccountLimit">
                  <el-button type="primary" size="small" @click="select()" v-show="SubAccountLimit">查询</el-button>
                  <!-- 个人实名认证 -->
                  <el-button type="warning" size="small" id="personalAuth" @click="PersonalAuthDialogForm  = true ">实名认证</el-button>
                  <!-- 组织实名认证 -->
                  <el-button type="warning" size="small" id="corpAuth" @click="CorpAuthDialogForm = true" v-show="false">实名认证</el-button>
                  <!-- 提现 -->
                  <el-button type="warning" size="small" id="goWithdraw" @click="withdrawMnoeyAlert()" v-show="false">提现</el-button>
                  <!--认证中 -->
                  <el-button type="warning" size="small" id="btnAuthing" v-show="false">认证中,请稍等</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="home-left-top-one" v-if="!UseSimpleView" >
            <div class="home-left-top-content">
              <h3 class="a-title">资金信息</h3>
              <div class="flex">
                <div class="home-left-top-capital">
                  <strong style="font-size:22px;color:#000">{{SubAccountLimit ? currAgentInfo.TotalDeposit : "***"}}</strong><br>
                  <span>总入金（{{CurrencyName}}）</span>
                </div>
                <div class="home-left-top-capital">
                  <strong style="font-size:22px;color:#000">{{SubAccountLimit ? currAgentInfo.TotalWithdraw : "***"}}</strong><br>
                  <span>已提取（{{CurrencyName}}）</span>
                </div>
                <div class="home-left-top-capital">
                  <strong style="font-size:22px;color:#000">{{SubAccountLimit ? currAgentInfo.FrozenMoney : "***"}}</strong><br>
                  <span>冻结资金（{{CurrencyName}}）</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="home-left-bottom">
          <el-tabs v-model="activeName">
            <el-tab-pane label="最近开户" name="first">
              <el-table :data="accountList" style="width: 100%" v-loading="loading">
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column prop="UserCode" label="客户代码">
                </el-table-column>
                <el-table-column prop="UserName" label="客户名称">
                </el-table-column>
                <el-table-column prop="FeeTemplateName" label="手续费模板">
                </el-table-column>
                <!-- <el-table-column prop="Phone" label="联系电话">
                  <template slot-scope="scope">
                    <span>{{scope.row.Phone == null ? "--" : (scope.row.Phone == "" ? "--" : scope.row.Phone)}}</span>
                    <el-button @click="viewprivacy(scope.row,scope)" type="text" v-show="scope.row.Phone == '******' ? true : false" size="small">查看</el-button>
                  </template>
                </el-table-column> -->
                <el-table-column prop="CreateDate" label="开户时间">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="最近提现" name="second" v-if="!UseSimpleView" >
              <el-table :data="withdrawList" style="width: 100%" v-loading="loading" >
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column label="操作日期" prop="OptDate">
                </el-table-column>
                <el-table-column prop="OptTime" label="操作时间">
                </el-table-column>
                <el-table-column prop="TransferMoney" :label="'提取金额（' + CurrencyName + '）'">
                </el-table-column>
                <el-table-column prop="Id" label="提取流水号">
                </el-table-column>
                <el-table-column prop="OrderState" label="状态">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="最近佣金" name="third" v-if="!UseSimpleView" >
              <el-table :data="commissionList" style="width: 100%" v-loading="loading" >
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column prop="CreateDate" label="结算日期">
                  <template slot-scope="scope">
                    <span>{{scope.row.CreateDate | datefmt("YYYY-MM-DD")}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CommissionProfit" label="当日佣金">
                </el-table-column>
                <el-table-column prop="Withdraw" label="当日提现">
                </el-table-column>
                <el-table-column prop="CurrencyNo" label="货币代码">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="home-right">
        <div class="bind-card" v-show="!displayCard">
          <div class="bind-card-button" @click="showBindCardPage(0)" v-show="SubAccountLimit">
            <div class="bind-card-button-in">
              +
            </div>
          </div>
          <p style="padding-top:23px;">新增银行卡</p>
        </div>
        <div class="bankCardInfo" v-show="displayCard && !UseSimpleView">
          <h3>我的银行卡</h3>
          <!-- <div class="mine-info-list1" v-show="SubAccountLimit"> -->
            <div class="" v-show="SubAccountLimit">
            <div class="mcode square">
              所属银行：{{bankCard.BankName}}
            </div>
            <div class="mname square">
              银行账号：{{bankCard.ViewCardNO}}
              <!-- <span style="color:#2399F1;cursor:pointer;padding-left:15px;" v-show="(bankCard.ViewCardNO == '' ||bankCard.ViewCardNO == null || bankCard.ViewCardNO == undefined) ? false : true" @click="showBindCardPage(1)">修改</span> -->
            </div>
            <!--
            <div class="mname square" v-show="(bankCard.UsdtAccount != '' && insTestProp.EnabledUsdt)">
              USDT钱包：{{bankCard.UsdtAccount}}
              <span style="color:#2399F1;cursor:pointer;padding-left:15px;"  @click="showBindCardPage(1)">修改</span>
            </div>
            -->
            <div class="mname " v-show="(bankCard.UsdtAccount == '' && insTestProp.EnabledUsdt)">
              &nbsp;
              <span style="color:#2399F1;cursor:pointer;padding-left:15px;"  ></span>
            </div>
          </div>
        </div>
        <div style="height:calc(100% - 200px)">
          <div :class="IsRegister == 0 ? 'Noregister mine-info':'mine-info'">
            <h3>我的信息</h3>
            <div class="mine-info-list" v-show="SubAccountLimit">
              <div class="mcode square">
                账户代码：{{currAgentInfo.AgentCode}}
              </div>
              <div class="mname square">
                我的姓名：{{currAgentInfo.AgentName}}
              </div>
              <div class="mphone square"  v-show="insTestProp.AgentRelyPhone">
                我的手机：
                <span style="color:#2399F1;cursor:pointer;" id="noPhone" @click="bindPhonePage = true"> 绑定 </span>
                <span style="color:#2399F1;cursor:pointer;" id="havePhone" v-show="false">{{currAgentInfo.BindPhone}}</span>
                <div style="color:#2399F1;cursor:pointer;padding-left:75px;" v-show="(currAgentInfo.BindPhone == '' ||currAgentInfo.BindPhone == null || currAgentInfo.BindPhone == undefined) ? false : true" @click="bindOldPhonePage = true">修改</div>
              </div>
            </div>
          </div>
          <div class="mine-2d-code" v-show="IsRegister">
            <h3>我的二维码</h3>
            <div class="mine-info-list flexwrap mine-info-list22" style="position: relative">
              <input id="text" type="text" />
              <div id="qrcode" class="codeImg" style="position: relative;">
                <div id="codeico"><img :src="'data:image/png;base64,' + insTestProp.InsLogo" alt=""></div>
              </div><br>
              <a href="javascript:;" class="copylink" @click="copyUrl()">复制链接</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hello flex" v-if="this.xx">
      <div class="home-left">
        <div class="home-left-top flex">
          <div class="home-left-top-one">
            <div class="home-left-top-content">
              <h3 class="a-title">
                <i class="iconfont icon-zijin "></i> 可用余额</h3>
              <div class="flex">
                <div class="home-left-top-capital">
                  <strong>{{currAgentInfo.CurrUsable}}</strong>
                  <span>{{CurrencyName}}</span><br>
                  <span>总收入（{{currAgentInfo.TotalCommissionProfit}} {{CurrencyName}}）</span>
                </div>
                <div class="home-left-top-option" v-show="SubAccountLimit">
                  <el-button type="primary" size="small" class="onebtn" @click="select()" style="padding: 8px 15px;">查询</el-button>
                  <!-- 个人实名认证 -->
                  <el-button type="warning" size="small" class="twobtn" id="personalAuth" @click="PersonalAuthDialogForm  = true">实名认证</el-button>
                  <!-- 组织实名认证 -->
                  <el-button type="warning" size="small" class="twobtn" id="corpAuth" @click="CorpAuthDialogForm = true" v-show="false">实名认证</el-button>
                  <!-- 提现 -->
                  <el-button type="warning" size="small" class="twobtn" id="goWithdraw" @click="withdrawMnoeyAlert()" v-show="false">提现</el-button>
                  <!--认证中 -->
                  <el-button type="warning" size="small" class="twobtn" id="btnAuthing" v-show="false">认证中,请稍等</el-button>
                </div>
              </div>
            </div>
            <div class="home-left-top-content" style="position: absolute;bottom:0;width: 100%;">
              <h3 class="a-title">资金信息</h3>
              <div class="flex">
                <div class="home-left-top-capital">
                  <strong style="font-size:22px;color:#000">{{currAgentInfo.TotalDeposit}}</strong><br>
                  <span>总入金（{{CurrencyName}}）</span>
                </div>
                <div class="home-left-top-capital">
                  <strong style="font-size:22px;color:#000">{{currAgentInfo.TotalWithdraw}}</strong><br>
                  <span>已提取（{{CurrencyName}}）</span>
                </div>
                <div class="home-left-top-capital">
                  <strong style="font-size:22px;color:#000">{{currAgentInfo.FrozenMoney}}</strong><br>
                  <span>冻结资金（{{CurrencyName}}）</span>
                </div>
              </div>
            </div>
          </div>
          <div class="home-left-top-two">
            <div class="bind-card rightline" v-show="!displayCard">
              <h3>
                <i class="iconfont icon-yinhangqia"></i> 新增银行卡</h3>
              <div class="bind-card-button" @click="showBindCardPage(0)" v-show="SubAccountLimit">
                <div class="bind-card-button-in">
                  +
                </div>
              </div>

            </div>
            <div class="bankCardInfo rightline" v-show="displayCard">
              <div class="mine-info-box">
                <h3>
                  <i class="iconfont icon-yinhangqia"></i> 我的银行卡</h3>
                <div class="mine-info-list1 mine-info-boxinfo" v-show="SubAccountLimit">
                  所属银行：{{bankCard.BankName}} </br>
                  银行账号：{{bankCard.ViewCardNO}}
                </div>
              </div>
            </div>

            <div class="mine-info rightline">
              <div class="mine-info-box">
                <h3>
                  <i class="iconfont icon-touxiang"></i> 我的信息</h3>
                <div class="mine-info-list mine-info-boxinfo " v-show="SubAccountLimit">
                  账户代码：{{currAgentInfo.AgentCode}} </br>
                  我的姓名：{{currAgentInfo.AgentName}} </br>
                  <template v-if="insTestProp.AgentRelyPhone">
                    我的手机：
                  <span style="color: #4be4c5;cursor:pointer;" id="noPhone" @click="bindPhonePage = true"> 绑定 </span>
                  <span style="color: #4be4c5;cursor:pointer;" id="havePhone" v-show="false">{{currAgentInfo.BindPhone}}</span>
                  <div style="color: #4be4c5;cursor:pointer;padding-left:75px;" v-show="(currAgentInfo.BindPhone == '' ||currAgentInfo.BindPhone == null || currAgentInfo.BindPhone == undefined) ? false : true" @click="bindOldPhonePage = true">修改</div>
                  </template>
                </div>
              </div>

            </div>

            <div class="mine-2d-code">
              <h3 style="text-align:center">
                <i class="iconfont icon-zijinzhanghu"></i> 我的二维码</h3>
              <div class="mine-info-list flexwrap mine-info-list22">
                <input id="text" type="text" />
                <div id="qrcode" class="codeImg" style="position: relative;">
                  <div id="codeico"><img src="../../static/agent-logo.png" alt=""></div>
                </div><br>

                <a href="javascript:;" class="copylink" @click="copyUrl()">复制链接</a>
              </div>
            </div>

          </div>
        </div>
        <div class="home-left-bottom">
          <el-tabs v-model="activeName">
            <el-tab-pane label="最近三个月开户" name="first">
              <el-table :data="accountList" style="width: 100%" v-loading="loading">
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column prop="UserCode" label="客户代码">
                </el-table-column>
                <el-table-column prop="UserName" label="客户名称">
                </el-table-column>
                <el-table-column prop="FeeTemplateName" label="手续费模板">
                </el-table-column>
                <!-- <el-table-column prop="Phone" label="联系电话">
                  <template slot-scope="scope">
                    <span>{{scope.row.Phone == null ? "--" : (scope.row.Phone == "" ? "--" : scope.row.Phone)}}</span>
                    <el-button @click="viewprivacy(scope.row,scope)" type="text" v-show="scope.row.Phone == '******' ? true : false" size="small">查看</el-button>
                  </template>
                </el-table-column> -->
                <el-table-column prop="CreateDate" label="开户时间">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="最近三个月提现" name="second">
              <el-table :data="withdrawList" style="width: 100%" v-loading="loading">
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column label="操作日期" prop="OptDate">
                </el-table-column>
                <el-table-column prop="OptTime" label="操作时间">
                </el-table-column>
                <el-table-column prop="TransferMoney" :label="'提取金额（' + CurrencyName + '）'">
                </el-table-column>
                <el-table-column prop="Id" label="提取流水号">
                </el-table-column>
                <el-table-column prop="OrderState" label="状态">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="最近三个月佣金" name="third">
              <el-table :data="commissionList" style="width: 100%" v-loading="loading">
                <el-table-column type="index" label="序号">
                </el-table-column>
                <el-table-column prop="CreateDate" label="结算日期">
                  <template slot-scope="scope">
                    <span>{{scope.row.CreateDate | datefmt("YYYY-MM-DD")}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CommissionProfit" label="当日佣金">
                </el-table-column>
                <el-table-column prop="Withdraw" label="当日提现">
                </el-table-column>
                <el-table-column prop="CurrencyNo" label="货币代码">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <!-- 实名认证弹窗 -->
    <el-dialog title="实名认证" :visible.sync="PersonalAuthDialogForm" :close-on-click-modal="false" class="alert_title alert_ttt" width="40%" style="overflow:hidden;" @close="resetFormimg('personalAuthForm')" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-form :model="personalAuthForm" :rules="rulesPersonalinfo" ref="personalAuthForm" label-width="100px" class="demo-personalAuthForm" size="small">
        <!-- 
          证件类型: 身份证与其他证件, 大陆身份证有正则验证, 其他证件没有
          2020年1月9日14:18:23
         -->
        <el-form-item label="证件类型：">
          <el-radio-group v-model="personalAuthForm.IdCardType" @change="IdCardTypeChangeFn">
            <el-radio :label="0">大陆身份证</el-radio>
            <el-radio :label="1">其他身份证件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="真实姓名：" prop="RealName">
          <el-input v-model.trim="personalAuthForm.RealName" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="IDCardNo">
          <el-input type="text" v-model.trim="personalAuthForm.IDCardNo" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
      </el-form>
      <div class="card_box" style="text-align:center;display:flex;overflow:hidden;margin-top:50px;">
        <div class="card_box_left" style="margin:0px auto;width:30%;height:180px;">
          <el-upload class="avatar-uploader uploadimg" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="changeFileFront">
            <img id="giftImgFront" v-if="personalAuthForm.IDCardFront" :src="personalAuthForm.IDCardFront" class="avatar">
            <el-button v-else slot="trigger" class="btn_card" size="small" type="primary" style="margin-top:70px;">身份证正面</el-button>
          </el-upload>
        </div>
        <div class="card_box_right" style="margin:0px auto;width:30%;height:180px;">
          <el-upload class="avatar-uploader uploadimg" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="changeFileBack">
            <img id="giftImgBack" v-if="personalAuthForm.IDCardBack" :src="personalAuthForm.IDCardBack" class="avatar">
            <el-button v-else slot="trigger" class="btn_card" size="small" type="primary" style="margin-top:70px;">手持身份证</el-button>
          </el-upload>
        </div>
        <div class="card_box_right" style="margin:0px auto;width:30%;height:180px;" v-if="!CertificationUpload">
          <el-upload class="avatar-uploader uploadimg" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="beforeUploadVideo1">
            <img id="giftImgCardPhoto" v-if="personalAuthForm.Video" :src="personalAuthForm.Video" class="avatar">
            <el-button v-else slot="trigger" class="btn_card" size="small" type="primary" style="margin-top:70px;">合同</el-button>
          </el-upload>
        </div>
        <div class="card_box_right" style="margin:0px auto;width:30%;height:180px;" v-if="CertificationUpload">
          <el-upload class="avatar-uploader uploadimg" :accept="videoAccept" action="" :auto-upload="false" :show-file-list="false" :on-change="beforeUploadVideo">
            <video :src="personalAuthForm.Video" v-if="personalAuthForm.Video" controlslist="nodownload" controls="controls" width="100%" style="margin:0px auto;width:100%;height:180px;"></video>
            <el-button v-else slot="trigger" class="btn_card" size="small" type="primary" style="margin-top:70px;">视频认证</el-button>
          </el-upload>
        </div>
      </div>
      <p style="margin-left:10px;color:red;margin-top:10px;" v-if="CertificationUpload" >* 视频认证,录制视频内容：<br/>&nbsp;&nbsp;&nbsp;&nbsp;本人***，身份证号：*****************                        ，我请求使用贵公司主账户所属机构子账户交易，已完全了解期货交易过程中所可能存在的盈利以及亏损风险，一切交易均为本人经过充分考虑后真实意愿展示，本人承诺绝不将交易账号及密码告知他人。期间所产生的一切亏损或盈利本人自行承担。本人账号为：************</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeimg()" size="small">取消</el-button>
        <el-button type="primary" @click="PersonalAuth('personalAuthForm')" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!-- 解绑原始手机 -->
    <el-dialog title="验证原始号码" :close-on-click-modal="false" center :visible.sync="bindOldPhonePage" class="alert_title" @close="resetForm('bindPhoneForm')" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="border-radius: 5px;">
      <el-form :model="bindPhoneForm" :rules="rulesPersonalAuth" ref="bindPhoneForm" label-width="100px" class="demo-bindPhoneForm" size="small">
        <el-form-item label="手机号：">
          <el-input v-model="currAgentInfo.BindPhone" readonly="" placeholder="请输入手机号码" style="color:blue;"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="phoneCode" class="phone_code">
          <el-input type="text" v-model="bindPhoneForm.phoneCode" placeholder="请输入验证码"></el-input>
          <el-button size="small" type="primary" @click="sendCode(1)" :disabled="isDisabled" v-loading="loading">{{buttonName}}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindPhone(1)" size="small">提交验证</el-button>
      </div>
    </el-dialog>
    <!-- 手机号绑定弹窗 -->
    <el-dialog title="手机号绑定" :close-on-click-modal="false" center :visible.sync="bindPhonePage" class="alert_title" @close="resetForm('bindPhoneForm')" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="border-radius: 5px;">
      <el-form :model="bindPhoneForm" :rules="rulesPersonalAuth" ref="bindPhoneForm" label-width="100px" class="demo-bindPhoneForm" size="small">
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="bindPhoneForm.phone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="phoneCode" class="phone_code">
          <el-input type="text" v-model="bindPhoneForm.phoneCode" placeholder="请输入验证码"></el-input>
          <el-button size="small" type="primary" @click="sendCode()" :disabled="isDisabled" v-loading="loading">{{buttonName}}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindPhone()" size="small">提交验证</el-button>
      </div>
    </el-dialog>
    <!-- 银行卡绑定弹窗 -->
    <el-dialog :title="bankCardtitle" :close-on-click-modal="false" center :visible.sync="bindCardPage" id="bindcard" class="alert_title" @close="resetForm('bindCardForm')" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="border-radius: 5px;">
      <el-form :model="bindCardForm" :rules="rules" ref="bindCardForm" label-width="140px" class="demo-bindCardForm" size="small">
        <el-form-item label="持卡人姓名：" prop="BankAccountName">
          <el-input v-model.trim="bindCardForm.BankAccountName" placeholder="请输入持卡人姓名"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号：" prop="CardNO" class="phone_code">
          <el-input type="text" v-model.trim="bindCardForm.CardNO" placeholder="请输入银行卡号"></el-input>
        </el-form-item>
        <el-form-item label="所属银行：" prop="BankName" class="phone_code">
          <el-select v-model="bindCardForm.BankName" class="bankname" clearable placeholder="请选择银行" style="width:100%;" @focus="GetBankName()" @change="PickBankName">
            <el-option v-for="item in banklists" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省份：" prop="ProvinceName" class="phone_code">
          <!-- <span style="color: #f56c6c;position: absolute;left:-66px">*</span> -->
          <el-select v-model="bindCardForm.ProvinceName" class="provinceName" clearable placeholder="请选择所属省份" style="width:100%;" @focus="GetProvArea()" @change="PickProvCode">
            <el-option v-for="item in ProvArealists" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市/县：" prop="CityName" class="phone_code">
          <!-- <span style="color: #f56c6c;position: absolute;left:-72px">*</span> -->
          <el-select v-model="bindCardForm.CityName" class="cityname" clearable placeholder="请选择所属市县" style="width:100%;" @change="PickCithCode">
            <el-option v-for="item in CityArealists" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支行名称：" prop="SubbranchName" class="phone_code"  v-if="bankTypeId!='5000'">
          <!-- <span style="color: #f56c6c;position: absolute;left:-96px">*</span> -->
          <el-select v-model="bindCardForm.SubbranchName" class="subbranchname" clearable placeholder="请选择开户支行名称" style="width:100%;" @change="PickOrga">
            <el-option v-for="item in GetOrgaNamelists" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支行名称："  v-if="bankTypeId=='5000'"   class="phone_code">
            <el-input  placeholder="请输入支行名称" v-model="bindCardForm.SubbranchName" clearable class="subbranchname"></el-input>
          </el-form-item>

          <el-form-item label="USDT钱包：" class="phone_code"  v-show="insTestProp.EnabledUsdt">
            <el-input v-model.trim="bindCardForm.UsdtAccount"  placeholder="请输入usdt钱包收款地址" onkeyup="this.value=this.value.replace(/\s+/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="USDT二维码：" class="phone_code"  v-show="insTestProp.EnabledUsdt">
            <div class="card_box" style="text-align:center;display:flex;overflow:hidden;margin-top:10px;">
              <div class="card_box_left" style="margin:0px auto;width:90%;min-height:200px;">
                <el-upload class="avatar-uploader uploadimg" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="changeFileQrCode">
                  <img id="usdtqrcodeImg" v-if="bindCardForm.UsdtQrCodePath" :src="bindCardForm.UsdtQrCode" class="avatar">
                  <el-button v-else slot="trigger" class="btn_card" size="small" type="primary">usdt收款二维码</el-button>
                </el-upload>
              </div>
            </div>            
          </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subSave('bindCardForm')" size="small">绑定</el-button>
      </div>
    </el-dialog>
    <!-- 提现窗口 -->
    <el-dialog title="提现申请" width="45%" :close-on-click-modal="false" center :visible.sync="WithdrawDialogForm" class="alert_title" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <p class="topp">温馨提醒: 
        <span v-show="AllowPayTime || ForbidHolidayPay">提现时间段为
          <span v-show="ForbidHolidayPay">工作日</span>
          <span>{{ AllowPayTime }}</span>, 
        </span>
        <span v-show="SingleLimit">
          每笔限额 {{ SingleLimit }} {{ LimitMoneyType === 0 ? CurrencyName : '人民币' }}, 
        </span>
        <span v-show="SingleDayLimit">
          每天累积限额 {{ SingleDayLimit }} {{ LimitMoneyType === 0 ? CurrencyName : '人民币' }}
        </span>
      .</p>
      <el-form :model="withdrawData" :rules="rulesCard" ref="withdrawData" label-width="100px" class="demo-bindCardForm" size="small">
        <el-form-item style="font-size:larger;margin-left:-88px;" >
          <span style="margin-right:30px;">提现到：</span>  
        <el-radio v-model="paychannel"  v-for="(item,index) in OnlineWithDrawChannelList "  :label="item.Code" @change="gotoOnlineChannel(index)" :key="index">{{item.Name}}</el-radio>
        <el-radio v-model="paychannel" label="paychannelusdt" @change="gotoUsdtChannel()" :key="paychannel" v-show="insTestProp.EnabledUsdt">USDT钱包 </el-radio>
        </el-form-item>
        <el-form-item label="所属银行：" v-show="paychannel!='paychannelusdt'">
          <el-input v-model="bankCard.BankName" class="bindPhone" disabled></el-input>
        </el-form-item>
        <el-form-item label="银行账号：" v-show="paychannel!='paychannelusdt'">
          <el-input v-model="bankCard.ViewCardNO" class="bindPhone" disabled></el-input>
        </el-form-item>
        <el-form-item label="USDT钱包：" v-show="paychannel == 'paychannelusdt' && insTestProp.EnabledUsdt">
          <el-input v-model="usdtAccount.AccountNO" class="bindPhone" disabled></el-input>
        </el-form-item>
        <el-form-item label="可提金额：">
          <el-input v-model="CrrryceUsable" class="bindPhone" disabled></el-input>
          <span style="position:absolute;top:0px;left:0px;">$</span>
        </el-form-item>
        <el-form-item label="提现金额：">
          <el-input v-model="withdrawData.Money" placeholder="请输入提现金额"></el-input>
          <span style="position:absolute;right:10px;top:0px;">{{ CurrencyName }}</span>
        </el-form-item>
        <el-form-item label="绑定手机：" v-show="insTestProp.AgentRelyPhone">
          <el-input v-model="currAgentInfo.BindPhone" class="bindPhone" disabled></el-input>
        </el-form-item>
        <el-form-item :label="insTestProp.AgentRelyPhone ? '验 证 码：' : '登陆密码：'" class="phone_code">
          <el-input :type="insTestProp.AgentRelyPhone ? 'text' : 'password'" v-model="withdrawData.VerifyCode" placeholder="请输入内容"></el-input>
          <el-button v-show="insTestProp.AgentRelyPhone" size="mini" type="primary" @click=" sendCodeWithdraw()" :disabled="isDisabled">{{buttonName}}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="WithdrawDialogForm = false" size="small">取消</el-button>
        <el-button type="primary" @click="withdrawMnoey()" size="small">提交申请</el-button>
      </div>
    </el-dialog>
    <el-dialog title="验证码确认" :close-on-click-modal="false" center :visible.sync="ViewPrivacy" class="alert_title" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" width="30%" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-form :model="ViewPrivacyData" :rules="rulesCard" ref="withdrawData" label-width="100px" class="demo-bindCardForm" size="small">

        <el-form-item label="验 证 码：" class="phone_code">
          <el-input type="number" v-model="withdrawData.VerifyCode" placeholder="请输入短信验证码"></el-input>
          <el-button size="mini" type="primary" @click=" sendCodeWithdraw()" :disabled="isDisabled">{{buttonName}}</el-button>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ViewPrivacy = false" size="small">取消</el-button>
        <el-button type="primary" @click="viewInfo(usercode,1,codeindex)" size="small">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../assets/lib/jquery.min.js";
import "../assets/lib/jquery.qrcode.min.js";
export default {
  name: "home",
  data() {
    var reg = /^1\d{10}$/;
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
        this.codephone = true;
      }
    };
    var regname = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
    var validName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("信息不能为空"));
//      } else if (!regname.test(value)) {
//        callback(new Error("请输入汉字"));
      } else {
        callback();
      }
    };
    var banknumber = /^([1-9]{1})(\d{14}|\d{15}|\d{16}|\d{17}|\d{18})$/;
    var validbanknumber = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入银行卡号"));
//      } else if (!banknumber.test(value)) {
//        callback(new Error("请输入正确格式的银行卡号"));
      } else {
        callback();
      }
    };
    var codeidreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    var validcodeid = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入身份证号"));
//      } else if (codeidreg.test(value) === false) {
//        callback(new Error("请输入正确格式的身份证号"));
      } else {
        callback();
      }
    };
    return {
      Agentcode: "",
      ml: "",
      xx: false,
      loading: "",
      imgAccept: "image/jpeg,image/jpg,image/png,image/bmp",
      videoAccept: "video/mp4,video/ogg,video/3gpp,video/flv,video/avi,video/wmv,video/rmvb",
      buttonName: "发送短信验证码",
      isDisabled: false,
      time: 60,
      codephone: false,
      currAgentInfo: {},
      activeName: "first",
      accountList: [],
      withdrawList: [],
      commissionList: [],
      PersonalAuthDialogForm: false,
      CorpAuthDialogForm: false,
      WithdrawDialogForm: false,
      bindPhonePage: false,
      bindOldPhonePage: false,
      bindCardPage: false,
      ViewPrivacy: false,
      ViewPrivacyData: {},
      userInfo: {},
      bindPhoneForm: {
        phone: "",
        phoneCode: ""
      },
      bindCardForm: {
        BankAccountName: "",
        CardNO: "",
        BankName: "", //所选银行名称
        ProvinceName: "",
        CityName: "",
        SubbranchName: "",
        PaymNumb: "",
        UsdtQrCode:"",
        UsdtQrCodePath:"",
        UsdtAccount:""
      },
      banklists: [], //银行名称列表
      bankTypeId: "",
      rules: {
        //验证
        // BankAccountName: [
        //   { min: 2, max: 12, message: "超过最大名称长度", trigger: "blur" },
        //   {
        //     required: true,
        //     min: 2,
        //     max: 5,
        //     validator: validName,
        //     trigger: "blur"
        //   }
        // ],
        // CardNO: [
        //   { required: true, validator: validbanknumber, trigger: "blur" }
        // ]
      },
      ProvArealists: [], //省份列表
      ProvAreaCode: "",
      CityArealists: [],
      cityId: "",
      GetOrgaNamelists: [],

      personalAuthForm: {
        IdCardType: 0,
        RealName: "",
        IDCardNo: "",
        IDCardFront: "",
        IdCardFrontPath: "",
        IDCardFrontExt: "",
        IDCardBack: "",
        IdCardBackPath: "",
        IDCardBackExt: "",
        BankCardPhoto: "",
        BankCardPhotoPath: "",
        BankCardPhotoExt: "",
        InsCode: "",
        InsUserCode: "",
        UserType: 3,
        ApplyDate: "",
        Video: "",
        VideoPath: "",
        VideoExt: ""
      },
      withdrawData: {
        Money: "",
        VerifyCode: "",
        ClientKey: "",
        VerifyCodeKey: ""
      },
      rulesBindPhone: {},
      rulesPersonalAuth: {
        phone: [
          { required: true, trigger: "blur", validator: validPhone } //这里需要用到全局变量
        ]
      },
      rulesPersonalinfo: {
        RealName: [{ required: true, validator: validName, trigger: "blur" }],
        IDCardNo: [{ required: true, validator: validcodeid, trigger: "blur" }]
      },
      rulesCard: {},
      currDate: "",
      YearsAgo: "",
      displayCard: false,
      displayUsdt: false,
      bankCard: {},
      usdtAccount: {},
      paychannel:'paychanneloffline',
      usercode: "",
      codeindex: 0,
      CrrryceUsable: "", //当前可用资金
      bankCardtitle: "",
       insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        AgentRelyPhone: true, // 依赖手机号
        InsLogo: "", // 机构logo
        UseCustomId: true, // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
        EnabledUsdt: false,
        AllowNonRealNameUserOpenPosition: false
      },
      SubAccountLimit: true,
      CertificationUpload: true,
      SingleLimit: 0, // 单笔限额
      SingleDayLimit: 0, // 累积限额
      LimitMoneyType: 0, // 金额类型 0美元 1人民币
      AllowPayTime: '', // 允许提现的时间
      ForbidHolidayPay: false, // 禁止节假日支付
      CurrencyName: '',
      UseSimpleView:false,
      IsRegister:"",
      OnlineWithDrawChannelList:[]
    };
  },
  created() {
    console.log(this.$emit('execut'))
    // this.$parent.executeheadermethod(true);
    document.getElementsByTagName("title")[0].innerText = '管理中心';
    this.IsRegister = Number(sessionStorage.getItem('IsRegister'));
    this.getInsTestPropFn();
    // console.log(this.insTestProp);
    this.$store.state.loaction = "/home";
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (sessionStorage.getItem("type") == "1"){
      if (sessionStorage.getItem("SubAccountLimit") != null && sessionStorage.getItem("SubAccountLimit") != "undefined") {
        this.SubAccountLimit = JSON.parse(sessionStorage.getItem("SubAccountLimit"));
        // console.log(this.SubAccountLimit);
      }
    }
    if (sessionStorage.getItem("CertificationUpload") != null && sessionStorage.getItem("CertificationUpload") != "undefined") {
      this.CertificationUpload = JSON.parse(sessionStorage.getItem("CertificationUpload"));
    }
    this.getCurrencyName();
    if (sessionStorage.getItem("UseSimpleView") != null){
          this.UseSimpleView = JSON.parse(sessionStorage.getItem("UseSimpleView"));
    }
  },
  mounted() {
    let newdate = new Date();
    let Year = newdate.getFullYear();
    let endMonth = newdate.getMonth() + 1;
    let endDate = newdate.getDate();
    this.currDate = Year + "-" + endMonth + "-" + endDate;
    let currMonth;
    // 如果是1月
    if (newdate.getMonth() == 0) {
      Year = newdate.getFullYear() - 1;
      currMonth = 11;
    } else if (newdate.getMonth() == 1) {
      // 如果是2月
      Year = newdate.getFullYear() - 1;
      currMonth = 12;
    } else if (newdate.getMonth() == 2) {
      // 如果是3月
      currMonth = 1;
    } else {
      currMonth = newdate.getMonth() - 2;
    }

    let currDate = this.getLastDay(Year, currMonth);
    this.YearsAgo = Year + "-" + currMonth + "-" + currDate;
    if (this.$Agentcode == "ml") {
      this.ml = true;
      this.xx = false;
    } else {
      this.xx = true;
      this.ml = false;
    }
    this.getAgentInfo();
    this.getAccountList();
    if (this.SubAccountLimit) {
      this.getWithdrawList();
      this.getCommissionList();
    }
    this.getBankCard();
    this.getUsdtAccount();
    
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    getInsTestPropFn() {  // 获取机构性质
      var insCode = this.$store.state.inscode;
      var postData = "insCode=" + insCode;
      var url = "/openinsuser/GetInsTestProp";
      this.$indexapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.insTestProp = response.Data;
          sessionStorage.setItem("insTestProp", JSON.stringify(this.insTestProp));
          // console.log("insTestProp内容：" + JSON.stringify(response.Data));
        } else {
          this.$alert(response.Msg);
        }
      });
    },
     IdCardTypeChangeFn (val) {
      if (val === 1) { // 其他证件
        this.rulesPersonalinfo.IDCardNo = [{ required: true, message: '请输入身份证号', trigger: 'blur' }]
      } else if (val === 0) { // 身份证
        var codeidreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;  
        var validcodeid = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请输入身份证号"));
          } else if (codeidreg.test(value) === false) {
            callback(new Error("请输入正确格式的身份证号"));
          } else {
            callback();
          }
        };
        this.rulesPersonalinfo.IDCardNo = [{ required: true, validator: validcodeid, trigger: 'blur' }]
      }
    },
    // 获取当前月的最后一天
    getLastDay(year, month) {
      var new_year = year; //取当前的年份
      var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        //如果当前大于12月，则年份转到下一年
        new_month -= 12; //月份减
        new_year++; //年份增
      }
      var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天
      return new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate(); //获取当月最后一天日期
    },
    viewprivacy(row, obj) {
      this.ViewPrivacy = true;
      this.usercode = row.UserCode;
      this.codeindex = obj.$index;
    },
    viewInfo(usercode, type, index) {
      if (this.withdrawData.VerifyCode == "") {
        this.$message.error("请输入短信验证码！");
        return;
      }
      let url = "/userprivacyauth/VerifyAuthInfo";
      let postData = {
        UserCode: usercode,
        Type: type,
        Phone: this.currAgentInfo.AccountPhone,
        Code: this.withdrawData.VerifyCode
      };
      //console.log(postData);
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.accountList[index].Phone = response.Data.Phone;
          this.ViewPrivacy = false;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },

    // 取消清空图片
    closeimg() {
      this.PersonalAuthDialogForm = false;
      this.personalAuthForm.IDCardFront = "";
      this.personalAuthForm.IDCardBack = "";
    },
    // 清空实名认证
    resetFormimg(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
      this.personalAuthForm.IDCardFront = "";
      this.personalAuthForm.IDCardBack = "";
    },
    // 清空验证
    resetForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    // 短信验证倒计时
    sendMsg() {
      let me = this;
      me.isDisabled = true;
      let interval = window.setInterval(function() {
        me.buttonName = "（" + me.time + "秒）重新发送";
        --me.time;
        if (me.time < 0) {
          me.buttonName = "发送短信验证码";
          me.time = 60;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    //查询
    select() {
      this.$router.push("/selects/accountreports");
    },
    //获取当前代理人手机号码及认证信息
    getAgentInfo() {
      let url = "/subagent/GetAgentInfo";
      this.$loginapi.post(url, this.userInfo.UserCode, response => {
        if (response.Ret == 0) {
          if (!response.Data.Balance) {
            //账户余额
            response.Data.Balance = 0;
          }
          if (!response.Data.TotalDeposit) {
            //总收入
            response.Data.TotalDeposit = 0;
          }
          if (!response.Data.TotalWithdraw) {
            //已提取
            response.Data.TotalWithdraw = 0;
          }
          if (!response.Data.FrozenMoney) {
            //冻结资金
            response.Data.FrozenMoney = 0;
          }
          if (!response.Data.CurrencyNo) {
            //资金单位
            response.Data.CurrencyNo = "美元";
          }
          if (!response.Data.PromoteQrcode) {
            //推广二维码
            response.Data.PromoteQrcode = "";
          }
          if (!response.Data.IsAuthed) {
            // 是否实名认证
            response.Data.IsAuthed = 0;
          }

          this.currAgentInfo = response.Data;
          if (
            this.currAgentInfo.BindPhone != null &&
            this.currAgentInfo.BindPhone != ""
          ) {
            $("#noPhone").hide();
            $("#havePhone").show();
          }

          this.getAgentAuthState();
          this.getBalanceInfo();
          this.getAgentPromoteQrcode();
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    getAgentAuthState() {
      let urlAuth = "/RealNameAuth/IsAuthed";
      this.$loginapi.post(urlAuth, "", response => {
        if (response.Ret == 0) {
          this.currAgentInfo.IsAuthed = response.Data.Result;
          if (this.currAgentInfo.IsAuthed == 0 && this.insTestProp.AllowNonRealNameUserOpenPosition == false) {
            //未认证
            $("#goWithdraw").hide();
            //根据用户性质判断是个人还是组织认证
            if (this.currAgentInfo.Property == 0) {
              //个人认证
              $("#personalAuth").show();
              $("#corpAuth").hide();
            } else if (this.currAgentInfo.Property == 1) {
              //组织认证
              $("#personalAuth").hide();
              $("#corpAuth").show();
            }
          } else if (this.currAgentInfo.IsAuthed == 1 || this.insTestProp.AllowNonRealNameUserOpenPosition) {
            //已认证
            if (this.SubAccountLimit){
              $("#goWithdraw").show();
            }
            $("#personalAuth").hide();
            $("#corpAuth").hide();
          } else if (this.currAgentInfo.IsAuthed == 2) {
            //正在认证
            $("#goWithdraw").hide();
            $("#personalAuth").hide();
            $("#corpAuth").hide();
            $("#btnAuthing").show();
          } else if (this.currAgentInfo.IsAuthed == 3) {
            //认证失败
            $("#goWithdraw").hide();
            //根据用户性质判断是个人还是组织认证
            if (this.currAgentInfo.Property == 0) {
              //个人认证
              $("#personalAuth").show();
              $("#personalAuth").val("认证失败,重新认证!");
              $("#corpAuth").hide();
            } else if (this.currAgentInfo.Property == 1) {
              //组织认证
              $("#personalAuth").hide();
              $("#corpAuth").show();
              $("#corpAuth").val("认证失败,重新认证!");
            }
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //获取当前登录代理的部分信息
    getBalanceInfo() {
      let url = "/Account/GetBalance";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          this.currAgentInfo.TotalCommissionProfit =
            response.Data.TotalCommissionProfit;
          this.currAgentInfo.UnBalanceCommissionProfit =
            response.Data.UnBalanceCommissionProfit;
          this.currAgentInfo.CurrUsable = response.Data.CurrUsable;
          this.CrrryceUsable = this.currAgentInfo.CurrUsable;
          this.currAgentInfo.TotalDeposit = response.Data.TotalDeposit;
          this.currAgentInfo.TotalWithdraw = response.Data.TotalWithdraw;
          this.currAgentInfo.FrozenMoney = response.Data.FrozenMoney;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //获取当前代理人推广链接
    getAgentPromoteQrcode() {
      var RegQrcodeUrl = sessionStorage.getItem("RegQrcodeUrl");
      //  console.log(RegQrcodeUrl);
      
      if (RegQrcodeUrl !== "" && RegQrcodeUrl !== "undefined") { // 已配置
        if (RegQrcodeUrl.indexOf("{insCode}") != -1) { // 含有机构代码占位符
          RegQrcodeUrl = RegQrcodeUrl.replace("{insCode}", this.userInfo.InsCode);
        }
        if (RegQrcodeUrl.indexOf("{agentId}") != -1) { // 含有代理代码占位符
          RegQrcodeUrl = RegQrcodeUrl.replace("{agentId}", this.userInfo.UserCode);
        }
        this.currAgentInfo.PromoteQrcode = RegQrcodeUrl;
      } else { // 未配置
        let PromoteLinkPara =
        "?insCode=" +
        this.userInfo.InsCode +
        "&agentId=" +
        this.userInfo.UserCode;
        this.currAgentInfo.PromoteQrcode =

          window.location.origin + "/#/iphonregister" + PromoteLinkPara;
      }
      // if (this.currAgentInfo.PromoteQrcode.indexOf("http") == -1) {
      //   this.currAgentInfo.PromoteQrcode =
      //     "http://" + this.currAgentInfo.PromoteQrcode;
      // }
      // console.log(this.currAgentInfo.PromoteQrcode);
      $("#qrcode").qrcode(this.currAgentInfo.PromoteQrcode);
      $("#text").val(this.currAgentInfo.PromoteQrcode);
      this.currAgentInfo.InsCode = sessionStorage
        .getItem("inscode")
        .toLowerCase();
      // $("#codeico").css("background-image", "url(../../agent-logo.png)");
    },
    //最近开户
    getAccountList() {
      this.loading = true;
      let url = "/mycustomer/QueryMyCustomers";
      let postData = {
        UserCode: "",
        UserSource: 0,
        BeginDate: this.YearsAgo,
        EndDate: this.currDate
      };

      this.$loginapi.postWithPage(url, 1, 10, postData, response => {
        if (response.Ret == 0) {
          this.loading = false;
          this.accountList = response.Data;
        } else {
          this.loading = false;
          this.$message.error(response.Msg);
        }
      });
    },
    //最近提现
    getWithdrawList() {
      this.loading = true;
      let url = "/report/QueryAgentHistoryMoneyTransfer";
      let postData = {
        WithDrawState: 0,
        BeginDate: this.YearsAgo,
        EndDate: this.currDate
      };
      this.$loginapi.postWithPage(url, 1, 10, postData, response => {
        if (response.Ret == 0) {
          this.loading = false;
          this.withdrawList = response.Data;
          // $.each(this.withdrawList, function(i, n) {
         
          //   let YMD = n.OptDate.split("/");
          //   YMD = YMD[2] + "-" + YMD[0] + "-" + YMD[1];
          //   n.OptDate = YMD;
          // });
        } else {
          this.loading = false;
          this.$message.error(response.Msg);
        }
      });
    },
    //最近佣金
    getCommissionList() {
      this.loading = true;
      let url = "/report/QryAgentDayCommissionHistory";
      let postData = {
        BeginDate: this.YearsAgo,
        EndDate: this.currDate
      };

      this.$loginapi.postWithPage(url, 1, 10, postData, response => {
        if (response.Ret == 0) {
          this.loading = false;
          this.commissionList = response.Data.Records;
        } else {
          this.loading = false;
          this.$message.error(response.Msg);
        }
      });
    },
    //复制链接
    copyUrl() {
      var Url = document.getElementById("text");
      Url.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message("已复制，可贴粘。");
    },
    //获取验证码
    sendCode(number) {
      if (number == 1) {
        this.codephone = true;
      }
      if (this.codephone == true) {
        this.loading = true;
        let url = "/common/SendVerifyCodeToPhone";
        let Phone = this.bindPhoneForm.phone;
        if (number == 1) {
          Phone = this.currAgentInfo.BindPhone;
        }
        //console.log(Phone);
        this.$loginapi.post(url, Phone, response => {
          if (response.Ret == 0) {
            this.loading = false;
            this.$message.success("验证码已发送，请注意查收!");
            this.sendMsg();
            this.codephone = false;
          } else {
            this.loading = false;
            this.$message.error(response.Msg);
          }
        });
      } else {
        this.$message.error("手机号输入有误！");
      }
    },
    sendCodeWithdraw() {
      if (
        this.currAgentInfo.BindPhone == "" ||
        this.currAgentInfo.BindPhone == null
      ) {
        this.$alert("手机号码未绑定，请先绑定手机号码！");
        return;
      }
      if (
        this.currAgentInfo.BindPhone.length < 11
      ) {
        this.$alert("手机号格式不正确！");
        return;
      }
      let url = "/common/SendVerifyCodeToPhone";
      this.$loginapi.post(url, this.currAgentInfo.BindPhone, response => {
        if (response.Ret == 0) {
          this.sendMsg();
          this.$message.success("验证码已发送，请注意查收!");
        } else {
          this.$message.error(response.Msg);
        }
      });
    },

    //绑定手机号
    bindPhone(number) {
      this.loading = true;
      let url = "/Account/BindPhone";

      let postData = {
        Phone: this.bindPhoneForm.phone,
        Code: this.bindPhoneForm.phoneCode
      };
      if (number == 1) {
        postData = {
          Phone: this.currAgentInfo.BindPhone,
          Code: this.bindPhoneForm.phoneCode
        };
      }
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.loading = false;
          if (number == 1) {
            this.$message.success("手机号码验证成功!");
            this.bindPhonePage = true;
            this.bindOldPhonePage = false;
            return;
          }
          this.$message.success("手机号码绑定成功!");
          this.currAgentInfo.BindPhone = this.bindPhoneForm.BindPhone;
          this.bindPhonePage = false;
          $("#noPhone").hide();
          $("#havePhone").show();
          this.getAgentInfo();
        } else {
          this.loading = false;
          this.$message.error(response.Msg);
        }
      });
    },
    //打开绑定银行卡页面
    showBindCardPage(n) {
      if (this.insTestProp.AgentRelyPhone) {
        if (
          this.currAgentInfo.BindPhone == null ||
          this.currAgentInfo.BindPhone == ""
        ) {
          this.$message.warning("手机号码未绑定，请先绑定手机号码！");
          return;
        }
      }
      if (n == 0) {
        this.bankCardtitle = "新增银行卡";
      } else if (n == 1) {
        this.bankCardtitle = "修改银行卡";
      }
      this.bindCardForm = {
        BankAccountName: "",
        CardNO: "",
        BankName: "",
        ProvinceName: "",
        CityName: "",
        SubbranchName: "",
        PaymNumb: ""
      };
      if (this.currAgentInfo.IsAuthed == 0) {
        this.$message.warning("请先进行实名认证！");
        return;
      } else if (this.currAgentInfo.IsAuthed == 2) {
        //正在认证
        this.$message.warning("实名认证正在审核，请稍后绑卡！");
        return;
      } else if (this.currAgentInfo.IsAuthed == 3) {
        this.$message.warning("实名认证认证失败，请重新提交实名认证信息！");
        return;
      }
      this.bindCardPage = true;

    },

    //删除银行卡
    UnBindBankCard() {
      let url = "/Account/UnBindBankCard";
      let postData = [];
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.$message.success("银行卡已解除绑定");
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
     // 获取提现通道信息
    GetWithDrawChannel () {
      let url = "/Account/GetWithDrawChannel";
      let postData =  "";
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          if(response.Data) {
            this.OnlineWithDrawChannelList=response.Data;
            this.paychannel=response.Data[0]['Code'];
            let obj=this.OnlineWithDrawChannelList[0];
            this.SingleLimit = obj.SingleLimit;
            this.SingleDayLimit = obj.SingleDayLimit;
            this.LimitMoneyType = obj.LimitMoneyType;
            this.AllowPayTime = obj.AllowPayTime;
            this.ForbidHolidayPay = obj.ForbidHolidayPay;

          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 提现
    withdrawMnoeyAlert() {
      if (!this.displayCard && !this.displayUsdt) {
        this.$message.warning("尚未绑定收款账户！");
        return;
      }
      this.GetWithDrawChannel();
      this.WithdrawDialogForm = true;
    },

    withdrawMnoey() {
      if (this.withdrawData.Money == "") {
        this.$message.error("请输入提现金额");
        return;
      }
      if (isNaN(this.withdrawData.Money)) {
        this.withdrawData.Money = "";
        this.$message.error("请输入一个正确的金额");
        return;
      }
      //&& this.paychannel == "paychanneloffline"
      if (!this.displayCard)
      {
        this.$message.error("没有绑定银行卡");
              return;
      }
      if (!this.displayUsdt && this.paychannel == "paychannelusdt")
      {
        this.$message.error("没有绑定USDT钱包");
              return;
      }

      if (this.withdrawData.Money != "") {
        //检查小数点后是否对于两位http://blog.csdn.net/shanzhizi
        if (
          this.withdrawData.Money.toString().split(".").length > 1 &&
          this.withdrawData.Money.toString().split(".")[1].length > 2
        ) {
          this.$message.error("输入金额最多两位小数");
          this.withdrawData.Money = "";
          return;
        }
      }
       if (this.insTestProp.AgentRelyPhone) {
        if (this.withdrawData.VerifyCode == '') {
          this.$message.error("请输入验证码");
          return;
        }
      } else {
        if (this.withdrawData.VerifyCode == '') {
          this.$message.error("请输入登陆密码");
          return;
        }
      }
      this.loading = true;
      let url = "/Account/Withdraw";

      if(this.paychannel=='paychannelusdt'){

          this.paychannel='usdt'
      }
      let postData = {
        Money: this.withdrawData.Money,
        VerifyCode: this.withdrawData.VerifyCode,
        ClientKey: "",
        VerifyCodeKey: this.currAgentInfo.BindPhone,
        PayChannel:this.paychannel
      };
      let money = this.withdrawData.Money;
      this.$loginapi.post(url, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          this.withdrawData.Money = "";
          this.withdrawData.VerifyCode = "";
          this.$message.success(response.Msg);
          this.WithdrawDialogForm = false;
          let _this = this;
          let timeshuaxun = setInterval(function() {
            _this.getBalanceInfo();
            _this.getWithdrawList();
            if (_this.withdrawData.Money < money) {
              clearInterval(timeshuaxun);
            }
          }, 1000);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    changeFileFront(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      this.personalAuthForm.IDCardFrontExt = file.raw.type;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
       this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 1 // 1: 身份证正面; 2: 身份证反面/手持身份证; 3: 银行卡; 4: 视频
       };
      let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.personalAuthForm.IDCardFront = this.result;
          };
          this.personalAuthForm.IdCardFrontPath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    changeFileBack(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      this.personalAuthForm.IDCardBackExt = file.raw.type;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 2
       };
      let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.personalAuthForm.IDCardBack = this.result;
          };
          this.personalAuthForm.IdCardBackPath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
      changeFileQrCode(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      this.bindCardForm.UsdtQrCodeExt = file.raw.type;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 9
      };
      let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.bindCardForm.UsdtQrCode = this.result;
            // This.bindCardPage = false;
            // This.bindCardPage = true;
            This.$forceUpdate();
          };
          this.bindCardForm.UsdtQrCodePath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    beforeUploadVideo1(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      this.personalAuthForm.VideoExt = file.raw.type;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 4
       };
        let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.personalAuthForm.Video = this.result;
          };
          this.personalAuthForm.VideoPath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 视频上传
    beforeUploadVideo(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;
      this.personalAuthForm.VideoExt = file.raw.type;
      if (
        [
          "video/mp4",
          "video/3gpp",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb"
        ].indexOf(file.raw.type) == -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt100M) {
        this.$message.error("上传视频大小不能超过 100MB哦!");
        return false;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 4
       };
      let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.personalAuthForm.Video = this.result;
          };
          this.personalAuthForm.VideoPath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.video = true;
      this.videourl = file.url;
    },
    PersonalAuth(formName) {
      let userInfo = this.userInfo;
      this.$refs[formName].validate(valid => {
        if (valid) {
          //个人验证
          // let url = "/RealNameAuth/SubmitInfoForMan";
          // if (this.personalAuthForm.IDCardFront == "") {
          //   this.$message.error("身份证正面不能为空");
          //   return false;
          // } else if (this.personalAuthForm.IDCardFront.length < 20) {
          //   this.$message.error("上传图片失败，请刷新后重新上传!");
          //   return false;
          // } else if (this.personalAuthForm.IDCardBack == "") {
          //   this.$message.error("手持身份证照片不能为空");
          //   return false;
          // } else if (this.personalAuthForm.IDCardBack.length < 20) {
          //   this.$message.error("上传图片失败，请刷新后重新上传!");
          //   return false;
          // } else if (this.personalAuthForm.Video == "") {
          //   this.$message.error("认证视频不能为空");
          //   return false;
          // } else if (this.personalAuthForm.Video.length < 20) {
          //   this.$message.error("上传视频失败，请刷新后重新上传!");
          //   return false;
          // }
          let url = "/RealNameAuth/SubmitInfoForManNew";
          if (this.personalAuthForm.IdCardFrontPath == "") {
            this.$message.error("身份证正面照片不能为空");
            return false;
          } else if (this.personalAuthForm.IdCardBackPath == "") {
            this.$message.error("手持身份证照片不能为空");
            return false;
          } else if (this.personalAuthForm.VideoPath == "") {
            this.$message.error("认证视频不能为空");
            return false;
          }
          this.loading = true;
          let postData = {
            RealName: this.personalAuthForm.RealName.replace(/\s+/g, ""),
            IDCardNo: this.personalAuthForm.IDCardNo.replace(/\s+/g, ""),
            // IDCardFront: this.personalAuthForm.IDCardFront.substring(
            //   this.personalAuthForm.IDCardFront.indexOf(",") + 1
            // ),
            IdCardFrontPath: this.personalAuthForm.IdCardFrontPath,
            IDCardFrontExt: this.personalAuthForm.IDCardFrontExt,
            // IDCardBack: this.personalAuthForm.IDCardBack.substring(
            //   this.personalAuthForm.IDCardBack.indexOf(",") + 1
            // ),
            IdCardBackPath: this.personalAuthForm.IdCardBackPath,
            IDCardBackExt: this.personalAuthForm.IDCardBackExt,
            IdCardType: this.personalAuthForm.IdCardType,
            InsCode: userInfo.InsCode,
            InsUserCode: userInfo.UserCode,
            UserType: userInfo.UserType,
            ApplyDate: new Date(),
            // Video: this.personalAuthForm.Video.substring(
            //   this.personalAuthForm.Video.indexOf(",") + 1
            // ),
            VideoPath: this.personalAuthForm.VideoPath,
            VideoExt: this.personalAuthForm.VideoExt
          };
          this.$loginapi.post(url, postData, response => {
            this.loading = false;
            if (response.Ret == 0) {
              this.$message.success("认证信息已提交,请等待审核!");
              this.getAgentAuthState();
              this.PersonalAuthDialogForm = false;
            } else {
              this.$message.error(response.Msg);
            }
          });
        } else {
          this.$message.warning("请按照提示完善信息！");
          return false;
        }
      });
    },
    getBankCard() {
      let url = "/Account/QueryBankCards";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.bankCard = response.Data[0];
            this.displayCard = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    getUsdtAccount() {
      let url = "/Account/QueryUsdtAccounts";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.usdtAccount = response.Data[0];
            this.displayUsdt = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    gotoOfflineChannel(){
      console.log(this.paychannel)
    },
    gotoUsdtChannel(){
      console.log(this.paychannel)
    },
    gotoOnlineChannel(index){

        let obj=this.OnlineWithDrawChannelList[index];
        this.SingleLimit = obj.SingleLimit;
        this.SingleDayLimit = obj.SingleDayLimit;
        this.LimitMoneyType = obj.LimitMoneyType;
        this.AllowPayTime = obj.AllowPayTime;
        this.ForbidHolidayPay = obj.ForbidHolidayPay;
    },
    // 获取银行名称
    GetBankName() {
      let url = "/openinsuser/GetBankName";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.banklists = response.Data;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    PickBankName(value) {
      this.bankTypeId = value;
      this.ProvArealists = null;
      this.bindCardForm.ProvinceName = null;
      this.CityArealists = null;
      this.bindCardForm.CityName = null;
      this.GetOrgaNamelists = null;
      this.bindCardForm.SubbranchName = null;
    },
    GetProvArea() {
      let url = "/openinsuser/GetProvArea";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.ProvArealists = response.Data;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    PickProvCode(value) {
      this.ProvAreaCode = value;
      this.CityArealists = null;
      this.bindCardForm.CityName = null;
      this.GetOrgaNamelists = null;
      this.bindCardForm.SubbranchName = null;
      this.GetCityArea(value);
    },
    GetCityArea(value) {
      if (value == "" || value == null) {
        return;
      }
      let url = "openinsuser/GetCityArea/";
      let postData = "provId=" + value;
      this.$indexapi.post(url, postData, res => {
        if (res.Ret == 0) {
          this.CityArealists = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    PickCithCode(value) {
      this.cityId = value;
      this.GetOrgaNamelists = null;
      this.bindCardForm.SubbranchName = null;
      this.GetOrgaName(value);
    },
    GetOrgaName(value) {
      if (value == "" || value == null) {
        return;
      }
      let url = "openinsuser/GetOrgaName/";
      let postData =
        "bankTypeId=" +
        this.bankTypeId +
        "&provId=" +
        this.ProvAreaCode +
        "&cityId=" +
        value;
      this.$indexapi.post(url, postData, res => {
        if (res.Ret == 0) {
          this.GetOrgaNamelists = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    PickOrga(value) {
      this.bindCardForm.PaymNumb = value;
    },
    //绑定银行卡
    subSave(formName) {
      if (this.currAgentInfo.IsAuthed == 0 && this.insTestProp.AllowNonRealNameUserOpenPosition == false) {
        this.$message.error("请先进行实名认证！");
        return;
      } else if (this.currAgentInfo.IsAuthed == 2) {
        //正在认证
        this.$message.error("实名认证正在审核，请稍后绑卡！");
        return;
      } else if (this.currAgentInfo.IsAuthed == 3) {
        this.$message.error("实名认证认证失败，请重新提交实名认证信息！");
        return;
      }
      this.bindCardForm.BankName = $(".bankname")
        .children(".el-input")
        .children("input")
        .val();
      this.bindCardForm.ProvinceName = $(".provinceName")
        .children(".el-input")
        .children("input")
        .val();
      this.bindCardForm.CityName = $(".cityname")
        .children(".el-input")
        .children("input")
        .val();

        if(this.bankTypeId=='5000'){
          
          this.bindCardForm.PaymNumb = '000000000000';
        }else{
        this.bindCardForm.SubbranchName = $(".subbranchname")
                .children(".el-input")
                .children("input")
                .val();
        }
      
      for (let key in this.bindCardForm) {
        if (this.bindCardForm.UsdtAccount != "")continue;
        if (this.bindCardForm[key] == "") {
          if (key == "BankAccountName") {
            this.$message.error("请填写账户名称！");
            return;
          }
          if (key == "CardNO") {
            this.$message.error("请填写银行卡号！");
            return;
          }
          if (key == "BankName") {
            this.$message.error("请填写所属银行！");
            return;
          }
          if (key == "ProvinceName") {
            this.$message.error("请填写银行卡所属省份！");
            return;
          }
          if (key == "CityName") {
            this.$message.error("请填写银行卡所属市/县！");
            return;
          }
          if (key == "SubbranchName") {
            this.$message.error("请填写银行卡所属支行名称！");
            return;
          }
          //  this.$message.error("请完整填写信息后提交！");
          // return;
        }
      }
      let url = "/Account/BindBankCard";
      this.bindCardForm.BankAccountName = this.bindCardForm.BankAccountName.replace(
        /\s+/g,
        ""
      );
      this.bindCardForm.CardNO = this.bindCardForm.CardNO.replace(/\s+/g, "");
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$loginapi.post(url, this.bindCardForm, response => {
            this.loading = false;
            if (response.Ret == 0) {
              this.$message.success("银行卡绑定成功!");
              this.bindCardForm = {};
              this.bindCardPage = false;
              this.getBankCard();
            } else {
              this.$message.error(response.Msg);
              // this.$message.error(response.Msg);
            }
          });
        } else {
          this.$message.error("填写信息有误请核对");
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
#codeico {
  position: absolute;
  z-index: 999;
  width: 30px;
  height: 30px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* background: url(../assets/images/SmartStar_logo.png) 50% no-repeat; */
  background-size: cover;
  background-color: #fff;
}
#codeico img {
  width: 100%;
  height: 100%;
}
/* .mine-2d-code:hover #codeico {
  display: none;
} */
.Noregister{
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue